import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getInitConfig } from 'ziphy-web-shared';
import { showAlert } from 'ziphy-web-shared/basic/lib/utilities';
import { useLivequeueWs } from 'ziphy-web-shared/basic/utils/useLivequeueWS';
export const useConsultationChatMessages = ({ onMessage }) => {
    const { t } = useTranslation();
    const wsOptions = useMemo(() => ({
        url: `${getInitConfig().apiService.urls.livequeueUrl}ws`,
        onMessage: onMessage,
        onOpen: () => console.log(`[WS connected]`),
        onClose: () => console.log(`[WS disconnected]`),
        onError: (err) => {
            showAlert.error(t('ws.error.main_error'));
        },
    }), []);
    const { connected, disconnect } = useLivequeueWs(wsOptions);
    useEffect(() => {
        return () => {
            disconnect();
        };
    }, [disconnect]);
};
